import { useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "@/components/common";
import { authService } from "@/services/authService";
import { extractErrorMessage } from "@/services/axiosConfig";
import "./LoginPage.css";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!token) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <h1 className="login-title">Link inválido</h1>
          <p className="login-sub">Este link de redefinição é inválido ou está incompleto.</p>
          <Link to="/login" className="login-link">
            Voltar ao login
          </Link>
        </div>
      </div>
    );
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError("As senhas não conferem.");
      return;
    }
    setSubmitting(true);
    try {
      await authService.resetPassword(token, password);
      navigate("/login", { replace: true });
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <h1 className="login-title">Definir nova senha</h1>
        <p className="login-sub">Escolha uma senha para acessar sua conta.</p>
        {error && <div className="login-error">{error}</div>}
        <label className="login-field">
          <span>Nova senha</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
            autoFocus
          />
        </label>
        <label className="login-field">
          <span>Confirmar senha</span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </label>
        <Button type="submit" variant="primary" disabled={submitting || !password}>
          {submitting ? "Salvando…" : "Salvar senha"}
        </Button>
      </form>
    </div>
  );
}
